import { brl } from "./PurchaseDialog";

const COLORS = { pending_approval: "text-sky-500", processing: "text-amber-500", completed: "text-emerald-500", failed: "text-rose-500", rejected: "text-rose-500" };

export const WithdrawalsList = ({ items, admin = false, testid = "withdrawals-list", onResolve }) => (
  items.length === 0 ? (
    <p className="text-xs text-muted-foreground" data-testid={`${testid}-empty`}>Nenhum saque ainda.</p>
  ) : (
    <div className="overflow-x-auto" data-testid={testid}>
      <table className="w-full text-sm min-w-[520px]">
        <thead className="text-xs uppercase tracking-wider text-muted-foreground">
          <tr className="border-b border-border">
            <th className="text-left py-2">Data</th>
            {admin && <th className="text-left">Usuário</th>}
            <th className="text-right">Valor</th><th className="text-right">Taxa</th><th className="text-right">Líquido</th>
            <th className="text-left pl-4">Status</th>
            {onResolve && <th />}
          </tr>
        </thead>
        <tbody>
          {items.map((w) => (
            <tr key={w.id} className="border-b border-border/50" data-testid={`withdrawal-row-${w.id}`}>
              <td className="py-2 text-xs text-muted-foreground">{new Date(w.created_at).toLocaleString("pt-BR")}</td>
              {admin && <td><div>{w.user_name}</div><div className="text-xs text-muted-foreground">Pix {w.pix_key_type}: {w.pix_key}</div></td>}
              <td className="text-right font-mono">{brl(w.amount)}</td>
              <td className="text-right font-mono text-muted-foreground">{brl(w.fee)}</td>
              <td className="text-right font-mono">{brl(w.net_amount)}</td>
              <td className={`pl-4 text-xs font-medium ${COLORS[w.status] || ""}`} title={w.error || ""}>{w.status_label}</td>
              {onResolve && (
                <td className="text-right whitespace-nowrap">
                  {w.status === "pending_approval" && (<>
                    <button className="text-xs text-emerald-500 underline mr-3" onClick={() => onResolve(w, "approve")} data-testid={`withdrawal-approve-${w.id}`}>Aprovar e pagar</button>
                    <button className="text-xs text-rose-500 underline" onClick={() => onResolve(w, "reject")} data-testid={`withdrawal-reject-${w.id}`}>Rejeitar</button>
                  </>)}
                  {w.status === "processing" && (<>
                    <button className="text-xs text-emerald-500 underline mr-3" onClick={() => onResolve(w, "completed")} data-testid={`withdrawal-mark-paid-${w.id}`}>Marcar pago</button>
                    <button className="text-xs text-rose-500 underline" onClick={() => onResolve(w, "refund")} data-testid={`withdrawal-refund-${w.id}`}>Estornar</button>
                  </>)}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
);
